import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as cls from "./references.module.scss";
import {
  Button,
  ErrataView,
  ErrataWidget,
  WidgetFrame,
} from "../../../personal-studio-components/studio";
import { useSelector } from "react-redux";
import CertificatesList from "../../components/certificatesList/CertificatesList";
import Loader from "../../components/loader/Loader";
import { Snackbar } from "@mui/material";
import { StudentService } from "../../components/studentService";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";

function References() {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [menu, setMenu] = useState(null);
  const [deliveryPlaceId, setDeliveryPlaceId] = useState(1);
  const [certificateTypeId, setCertificateTypeId] = useState(null);
  const [referenceName, setReferenceName] = useState("");
  const [currentCourseIdx, setCurrentCourseIdx] = useState(0);
  const [menuItemData, setMenuItemData] = useState({});
  const [counter, setCounter] = useState(1);
  const [createCertProcess, setCreateCertProcess] = useState(null);
  const [response, setResponse] = useState(null);
  const [data, setData] = useState(null);

  const { handleSubmit, register } = useForm();
  async function getList() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/certificates/list",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      await StudentService.send(request, (response) => {
        if (response) {
          setData(response);

          if (response.errors) {
            const errorEvent = new ErrorEvent("error", {
              error: response,
            });
            window.dispatchEvent(errorEvent);
            return;
          }
        }
      });
    }
  }
  async function getCertificatesMenu() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/certificates/menu",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      await StudentService.send(request, (response) => {
        if (response) {
          setMenu(response);
          //console.debug("References:", menu);
          setMenuItemData(response[0]);
          setReferenceName(response[0].certificate_type_full_name);
          setCertificateTypeId(response[0].certificate_type_id);
          if (response.errors) {
            const errorEvent = new ErrorEvent("error", {
              error: response,
            });
            window.dispatchEvent(errorEvent);
            return;
          }
        }
      });
    }
  }

  async function createCertificate(formData) {
    formData.reason_invitation_id = Number(formData.reason_invitation_id);
    for (const key in formData) {
      if (!formData[key] || formData[key] === "Не выбрано")
        delete formData[key];
    }
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/certificates/create",
        data: {
          ...formData,
          access_token,
          study_contract_id: contractId,
          count_copies: counter,
          delivery_place_id: deliveryPlaceId,
          check: true,
        },
      };
      setCreateCertProcess("process");

      const data = await StudentService.send(request, setResponse);
      if (!data.errors) {
        const request = {
          method: "post",
          path: "/student/applications/certificates/create",
          data: {
            ...formData,
            access_token,
            study_contract_id: contractId,
            count_copies: counter,
            delivery_place_id: deliveryPlaceId,
            check: false,
          },
        };
        setTimeout(() => {
          getList();
        }, 2000);
        const data = await StudentService.send(request, setResponse);
        if (!data.errors) {
          setCreateCertProcess("success");
          window.open(data.url);
          setTimeout(() => {
            setCreateCertProcess(null);
          }, 5000);
        } else {
          const errorEvent = new ErrorEvent("error", {
            error: data,
          });
          window.dispatchEvent(errorEvent);
          setCreateCertProcess(null);
        }
      } else {
        const errorEvent = new ErrorEvent("error", {
          error: data,
        });
        window.dispatchEvent(errorEvent);
        setCreateCertProcess(null);
      }
    }
  }

  const handleChangeMenuElement = (idx, certificate_type_id) => {
    setCurrentCourseIdx(idx);
    setCertificateTypeId(certificate_type_id);
    setMenuItemData(menu[idx]);
    setReferenceName(menu[idx].certificate_type_full_name);
  };

  const handleOptionChange = (option) => {
    setDeliveryPlaceId(option);
  };

  useEffect(() => {
    getCertificatesMenu();
  }, []);

  if (menu)
    return (
      <>
        <WidgetFrame type="blue" icon="survey" title="Подать заявку">
          {menu.errors ? (
            <>
              {menu.error_type === "info" ? (
                <ErrataViewInfo errata={menu} />
              ) : (
                <ErrataView errata={menu} />
              )}
            </>
          ) : (
            <>
              <div>
                {menu.map(
                  (
                    { certificate_type_short_name, certificate_type_id },
                    idx
                  ) => (
                    <span
                      key={idx}
                      className={`${cls.menuItem} ${
                        currentCourseIdx === idx ? cls.active : ""
                      }`}
                      onClick={() =>
                        handleChangeMenuElement(idx, certificate_type_id)
                      }
                    >
                      {certificate_type_short_name}
                    </span>
                  )
                )}
              </div>
              <div className={cls.title}>{referenceName}</div>
              <form
                onSubmit={handleSubmit((formData) =>
                  createCertificate({
                    ...formData,
                    certificate_type_id: certificateTypeId,
                  })
                )}
              >
                {certificateTypeId === 1 && (
                  <div>
                    <div>
                      <div>Наименование работодателя</div>
                      <input
                        className={cls.input}
                        {...register("organization_name")}
                      />
                    </div>
                    <div>
                      <div>Вид аттестационных мероприятий</div>
                      <select
                        className={cls.select}
                        {...register("reason_invitation_id")}
                        fullWidth
                      >
                        <option disabled selected value={null}>
                          Не выбрано
                        </option>
                        {menuItemData?.reason_invitations?.map(
                          ({
                            reason_invitation_id,
                            reason_invitation_name,
                          }) => (
                            <option
                              key={reason_invitation_id}
                              value={reason_invitation_id}
                            >
                              {reason_invitation_name}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <div>
                      <div>Фамилия в дательном падеже *</div>
                      <input
                        className={cls.input}
                        {...register("surname_datel")}
                      />
                    </div>
                    <div>
                      <div>Имя в дательном падеже *</div>
                      <input
                        className={cls.input}
                        {...register("name_datel")}
                      />
                    </div>
                    <div>
                      <div>Отчество в дательном падеже</div>
                      <input
                        className={cls.input}
                        {...register("secname_datel")}
                      />
                    </div>
                  </div>
                )}
                {certificateTypeId === 2 && (
                  <div className={cls.copyCountContainer}>
                    <div>Количество копий</div>
                    <div className={cls.btnContainer}>
                      <button
                        type="button"
                        onClick={() => setCounter((prev) => prev - 1)}
                        className={cls.btn}
                      >
                        -
                      </button>
                      <div className={cls.counter}>{counter}</div>

                      <button
                        type="button"
                        onClick={() => setCounter((prev) => prev + 1)}
                        className={cls.btn}
                      >
                        +
                      </button>
                    </div>
                  </div>
                )}
                <div className={cls.deliveryPlace}>
                  <label className={cls.note}>Место получения справки</label>
                  <label className={cls.address}>
                    <input
                      type="radio"
                      name="paymentOption"
                      checked={deliveryPlaceId === 1}
                      onChange={() => handleOptionChange(1)}
                    />
                    Айдинг-центр
                  </label>
                  <label className={cls.address}>
                    <input
                      type="radio"
                      name="paymentOption"
                      checked={deliveryPlaceId === 2}
                      onChange={() => handleOptionChange(2)}
                    />
                    Офис-центр УМНЕЙ (109029, г. Москва, вн.тер.г. муниципальный
                    округ Таганский, ул. Нижегородская, д. 32, стр. 4)
                  </label>
                </div>
                {createCertProcess === "process" ? (
                  <Loader />
                ) : (
                  <Button type="primary">Подать заявку</Button>
                )}
              </form>
            </>
          )}
        </WidgetFrame>
        <WidgetFrame type="blue" icon="survey" title="История обращений">
          <CertificatesList getList={getList} data={data} setData={setData} />
          <Snackbar
            message="Заявка успешно подана. Пожалуйста, дождидесь загрузки документа"
            open={createCertProcess === "success"}
          />
        </WidgetFrame>
      </>
    );
}

export default References;
/* Формат данных:
[
  {
    "certificate_type_id": 1,
    "localization_key": "menu_callerCert",
    "certificate_type_full_name": "Справка-вызов (или справка о сроках сессии)",
    "certificate_type_short_name": "Справка-вызов",
    "file_path": "C:\\reports\\director",
    "is_for_lcc": true,
    "max_number": 1,
    "reason_invitations": [
      {
        "reason_invitation_id": 2,
        "reason_invitation_name": "промежуточной аттестации"
      },
      {
        "reason_invitation_id": 3,
        "reason_invitation_name": "государственной итоговой аттестации"
      },
      {
        "reason_invitation_id": 8,
        "reason_invitation_name": "установочной сессии"
      }
    ]
  },
  {
    "certificate_type_id": 2,
    "localization_key": "menu_wimsCert",
    "certificate_type_full_name": "Справка для предъявления по месту требования",
    "certificate_type_short_name": "Справка для предъявления по месту требования",
    "file_path": "C:\\reports\\director",
    "is_for_lcc": true,
    "max_number": 5,
    "reason_invitations": [
      {
        "reason_invitation_id": null,
        "reason_invitation_name": null
      }
    ]
  }
]
*/
